const React = require('react');

const Columns = require('../layout/Columns.jsx');
const CommonTypes = require('../common/Types.jsx');
const Component = require('../common/Component.jsx');
const Config = require('../utility/Config.jsx');
const Container = require('../common/Container.jsx');
const Item = require('./Item.jsx');
const ItemMeta = require('./ItemMeta.jsx');
const ItemV2 = require('../common/ItemV2.jsx');
const Name = require('../utility/Name.jsx');
const Token = require('../utility/Token.jsx');
const _TypeConfig = require('../common/TypeConfig.jsx');
const Utilities = require('../utility/Utilities.jsx');

const ItemBlocks = {
    get: (group, data) => [
        ...CommonTypes.BlocksV2.content.get(group),
        {
            id: Name.Block.Inventory.Image,
            component: ItemV2.Image.Component,
            config: {
                Block: ItemV2.Image.TypeConfig.panel.block(),
                Style: ItemV2.Image.TypeConfig.panel.style()
            },
            display: 'Item Image',
            group,
            image: ''
        },
        {
            id: Name.Block.Inventory.Meta,
            component: ItemMeta.Component,
            config: {
                Block: ItemMeta.TypeConfig.panel.block(),
                Style: ItemMeta.TypeConfig.panel.style(),
                Description: ItemMeta.TypeConfig.panel.description(),
                Label: ItemMeta.TypeConfig.panel.label(),
                Value: ItemMeta.TypeConfig.panel.value(data)
            },
            display: 'Item Meta',
            group,
            image: ''
        }
    ]
};

function _ItemContainerV2(props) {
    const config = props.config || {};
    const blockConfig = config.config && config.config.Block || {};
    const visibility = props.config && props.config.config && props.config.config.Visibility
    const visibilityHash = Utilities.Config.getVisibilityHash({ block: config });

    let columnSpacing, rowSpacing;
    const options = Utilities.Config.getStyleV2(blockConfig, undefined, (name, value, obj) => {
        switch (name) {
            case 'columnCount':
            case 'itemsPerPage':
                let temp = parseInt(value, 10);
                if (!isNaN(temp) && temp > 0) {
                    obj[name] = temp;
                }
                return true;
            case 'columnSpacing':
                columnSpacing = value;
                return true;
            case 'rowSpacing':
                rowSpacing = value;
                return true;
        }
    })
    options.columnCount = options.columnCount || 2;
    options.itemsPerPage = options.itemsPerPage || 4;
    if (options.itemsPerPage < options.columnCount) {
        options.columnCount = options.itemsPerPage;
    }
    options.rowCount = Math.ceil(options.itemsPerPage / options.columnCount);
    const inventory = props.data && props.data.Inventory || [];
    let inventoryLength = inventory.length;
    if (props.builder && inventoryLength > options.itemsPerPage) {
        inventoryLength = options.itemsPerPage;
    }
    const pageCount = Math.ceil(inventoryLength / options.itemsPerPage);
    let contentConfig;
    if (blockConfig.design && blockConfig.design.Config && blockConfig.design.Config.blocks && blockConfig.design.Config.blocks.length > 0) {
        contentConfig = blockConfig.design;
    }
    const spacingForItem = (index, count, spacing) => {
        if (spacing && spacing.value && spacing.unit) {
            const spacingFraction = parseFloat(spacing.value / count);
            const modulo = index % count;
            return {
                paddingLeft: `${parseFloat(modulo * spacingFraction)}${spacing.unit}`,
                paddingRight: `${parseFloat((count - modulo - 1) * spacingFraction)}${spacing.unit}`
            };
        }
    }
    const columnStyle = [];
    for (let i = 0; i < options.columnCount; i++) {
        let _style = { verticalAlign: options[`align-col${i + 1}`] || 'middle' };
        const temp = spacingForItem(i, options.columnCount, columnSpacing);
        if (temp) {
            _style = { ..._style, ...temp };
        }
        columnStyle.push(_style);
    }
    const containerForRow = (rowIndex, rowData, rowSpacing, options) => {
        const _columnCount = Math.min(rowData.length, options.columnCount);
        const width = `${100.0 / (_columnCount || 1)}%`;
        const componentData = rowData.map((d, i) => {
            let style = { width };
            if (_columnCount == options.columnCount) {
                if (columnStyle[i]) {
                    style = { ...style, ...columnStyle[i] }
                }
            } else {
                const temp = spacingForItem(i, _columnCount);
                if (temp) {
                    style = { ...style, ...temp }
                }
            }
            return (
                <td key={i} style={style}>
                    <ItemContentContainer
                        config={contentConfig}
                        data={props.data}
                        itemData={d}
                        kit={props.kit}
                        serverSide={props.serverSide}
                        visibility={visibility}
                        visibilityHash={visibilityHash} />
                </td>
            )
        })
        let style;
        const spacing = spacingForItem(rowIndex, options.rowCount, rowSpacing);
        if (spacing) {
            style = { paddingBottom: spacing.paddingRight, paddingTop: spacing.paddingLeft };
        }
        return (
            <table key={rowIndex} border="0" cellPadding="0" cellSpacing="0" style={style} width="100%">
                <tbody>
                    <tr>{componentData}</tr>
                </tbody>
            </table>
        )
    }
    const containerForPage = (index, rows, pageHeader, pageCount) => {
        let pageClassName;
        if (index < pageCount - 1) {
            pageClassName = 'pageBreakAfterAlways';
        }
        return props.onPageForItem(index, rows, pageHeader, pageClassName);
    }
    const content = [];
    const pageHeader = props.onPageHeader();
    let componentData = [];
    let rows = [];
    for (let i = 0; i < inventoryLength; i++) {
        if (i > 0 && i % options.itemsPerPage == 0) {
            // End of current page
            if (componentData.length > 0) {
                // Add remaining row content
                rows.push(containerForRow(rows.length, componentData, rowSpacing, options));
                componentData = [];
            }

            // Create page for row content
            content.push(containerForPage(content.length, rows, pageHeader, pageCount));
            rows = [];
        }

        // Add row content
        componentData.push(inventory[i]);
        if (componentData.length >= options.columnCount) {
            // Add row content to current page content
            rows.push(containerForRow(rows.length, componentData, rowSpacing, options));
            componentData = [];
        }
    }
    if (componentData.length > 0) {
        // Add remaining row content
        rows.push(containerForRow(rows.length, componentData, rowSpacing, options));
    }
    if (rows.length > 0) {
        // Create remaining page for row content
        content.push(containerForPage(content.length, rows, pageHeader, pageCount));
    }
    return (
        <Container
            builder={props.builder}
            className={props.className}
            config={props.config}
            dataType="layout"
            onClick={props.onClick}
            onDragEnter={props.onDragEnter}
            onDragStart={props.onDragStart}>
            <tr>
                <td>
                    {content}
                </td>
                {
                    props.builder &&
                    <td>
                        {
                            !contentConfig &&
                            Utilities.Builder.emptyBlockPlaceholder()
                        }
                        {Utilities.Builder.dragOutline()}
                    </td>
                }
            </tr>
        </Container>
    );
}
const ItemContainerV2 = Component.withPageHandler(_ItemContainerV2, true);

const ItemContentContainer = Config.withBlockRendering(ItemV2.Container.Component, ItemBlocks.get());

const TypeConfigV2 = {
    defaultDesign: (data) => ({
        "Config": {
            "blocks": [
                {
                    "config": {
                        "Block": {
                            "maxHeight": {
                                "unit": "px",
                                "value": "300"
                            },
                            "maxWidth": {
                                "unit": "px",
                                "value": ""
                            }
                        },
                        "Style": {
                            "paddingBottom": {
                                "unit": "px",
                                "value": "20"
                            },
                            "textAlign": "center"
                        }
                    },
                    "id": `${Name.Block.Inventory.Image}-${new Date().getTime()}`,
                    "type": {
                        "value": Name.Block.Inventory.Image
                    }
                },
                {
                    "config": {
                        "Block": {
                            "count": "1",
                            "displayType": "columns",
                            "rowCount": "1"
                        },
                        "Style": {},
                        "Description": {},
                        "Label": {},
                        "Value": {
                            "design": ItemMeta.TypeConfig.defaultDesign(data)
                        }
                    },
                    "id": `${Name.Block.Inventory.Meta}-1-${new Date().getTime()}`,
                    "type": {
                        "value": Name.Block.Inventory.Meta
                    }
                },
                {
                    "config": {
                        "Block": {
                            "count": "1",
                            "displayType": "columns",
                            "rowCount": "1"
                        },
                        "Style": {
                            "paddingRight": {
                                "unit": "px",
                                "value": "20"
                            }
                        },
                        "Description": {},
                        "Label": {},
                        "Value": {
                            "design": ItemMeta.TypeConfig.defaultDesignSku()
                        }
                    },
                    "id": `${Name.Block.Inventory.Meta}-2-${new Date().getTime()}`,
                    "type": {
                        "value": Name.Block.Inventory.Meta
                    }
                }
            ]
        },
        "Type": Name.Content.MosaicItem
    }),
    dropdown: {
        alignment: () => [
            { display: 'Top', value: 'top' },
            { display: 'Middle', value: 'middle' },
            { display: 'Bottom', value: 'bottom' }
        ]
    },
    panel: {
        block: () => {
            const group = 'block';
            return {
                group,
                label: 'Design',
                options: [
                    {
                        display: 'Edit Item Content',
                        fullWidth: true,
                        group,
                        offsetTop: true,
                        type: 'edit-button',
                        value: {
                            keyPath: ['Block', 'design'],
                            name: Name.Content.MosaicItem
                        }
                    },
                    {
                        fullWidth: true,
                        group,
                        type: 'info',
                        value: '* Items Per Page is best-effort, so some items may appear on a separate page'
                    },
                    {
                        display: 'Column Count',
                        group,
                        name: 'columnCount',
                        options: [
                            { display: '2', value: '2' },
                            { display: '3', value: '3' },
                            { display: '4', value: '4' }
                        ],
                        type: 'dropdown',
                        value: '2'
                    },
                    {
                        display: 'Items Per Page',
                        group,
                        name: 'itemsPerPage',
                        options: [
                            { display: '2', value: '2' },
                            { display: '3', value: '3' },
                            { display: '4', value: '4' },
                            { display: '5', value: '5' },
                            { display: '6', value: '6' },
                            { display: '7', value: '7' },
                            { display: '8', value: '8' },
                        ],
                        type: 'dropdown',
                        value: '4'
                    },
                    {
                        display: 'Column Spacing',
                        fullWidth: true,
                        group,
                        name: 'columnSpacing',
                        options: _TypeConfig.dropdown.measurement(),
                        type: 'measurement-slider',
                        value: { 
                            'unit': 'px',
                            'value': '20'
                        }
                    },
                    {
                        display: 'Row Spacing',
                        fullWidth: true,
                        group,
                        name: 'rowSpacing',
                        options: _TypeConfig.dropdown.measurement(),
                        type: 'measurement-slider',
                        value: { 
                            'unit': 'px',
                            'value': '20'
                        }
                    },
                    {
                        display: 'Column 1 Alignment',
                        group,
                        name: 'align-col1',
                        options: TypeConfigV2.dropdown.alignment(),
                        type: 'dropdown',
                        value: 'middle'
                    },
                    {
                        display: 'Column 2 Alignment',
                        group,
                        name: 'align-col2',
                        options: TypeConfigV2.dropdown.alignment(),
                        type: 'dropdown',
                        value: 'middle'
                    },
                    {
                        display: 'Column 3 Alignment',
                        group,
                        name: 'align-col3',
                        options: TypeConfigV2.dropdown.alignment(),
                        type: 'dropdown',
                        value: 'middle',
                        visible: (config) => config.Block && (config.Block.columnCount == '3' || config.Block.columnCount == '4')
                    },
                    {
                        display: 'Column 4 Alignment',
                        group,
                        name: 'align-col4',
                        options: TypeConfigV2.dropdown.alignment(),
                        type: 'dropdown',
                        value: 'middle',
                        visible: (config) => config.Block && config.Block.columnCount == '4'
                    }
                ]
            }
        },
        style: () => _TypeConfig.panel.layoutStyleV2('style', undefined, {}, undefined, {}),
        visibility: () => {
            return {
                expanded: false,
                label: 'Visibility',
                options: [
                    { display: 'Edition Info', name: Token.Inventory.Edition, type: 'checkbox', value: true, configurableDuringExport: (_, config) => Token.isTokenPresent(Token.Inventory.Edition, config, Name.Block.Inventory.Meta) },
                    { display: 'Created Date', name: Token.Date, type: 'checkbox', value: true, configurableDuringExport: (_, config) => Token.isTokenPresent(Token.Date, config, Name.Block.Inventory.Meta) },
                    { display: 'Medium', name: Token.Inventory.Medium, type: 'checkbox', value: true, configurableDuringExport: (_, config) => Token.isTokenPresent(Token.Inventory.Medium, config, Name.Block.Inventory.Meta) },
                    { display: 'Signature Placement', name: Token.Inventory.Signature, type: 'checkbox', value: true, configurableDuringExport: (_, config) => Token.isTokenPresent(Token.Inventory.Signature, config, Name.Block.Inventory.Meta) },
                    { display: 'Dimensions', name: Token.Inventory.Dimensions, type: 'checkbox', value: true, configurableDuringExport: (_, config) => Token.isTokenPresent(Token.Inventory.Dimensions, config, Name.Block.Inventory.Meta) },
                    { display: 'Alternate Dimensions', name: Token.Inventory.AlternateDimensions, type: 'checkbox', value: true, configurableDuringExport: (_, config) => Token.isTokenPresent(Token.Inventory.AlternateDimensions, config, Name.Block.Inventory.Meta) },
                    { display: 'Framing', name: Token.Inventory.Framed, type: 'checkbox', value: true, configurableDuringExport: (_, config) => Token.isTokenPresent(Token.Inventory.Framed, config, Name.Block.Inventory.Meta) },
                    { display: 'Inventory Number', name: Token.Inventory.Number, type: 'checkbox', value: true, configurableDuringExport: (_, config) => Token.isTokenPresent(Token.Inventory.Number, config, Name.Block.Inventory.Meta) },
                    { display: 'SKU', name: Token.Inventory.SKU, type: 'checkbox', value: true, configurableDuringExport: (_, config) => Token.isTokenPresent(Token.Inventory.SKU, config, Name.Block.Inventory.Meta) },
                    { display: 'Location', name: Token.Inventory.Location, type: 'checkbox', value: true, configurableDuringExport: (_, config) => Token.isTokenPresent(Token.Inventory.Location, config, Name.Block.Inventory.Meta) },
                    { display: 'Retail Price', name: Token.Inventory.Price, type: 'checkbox', value: true, configurableDuringExport: (_, config) => Token.isTokenPresent(Token.Inventory.Price, config, Name.Block.Inventory.Meta) },
                    { display: 'Alternate Prices', name: Token.Inventory.AlternatePrices, type: 'checkbox', value: true, configurableDuringExport: (_, config) => Token.isTokenPresent(Token.Inventory.AlternatePrices, config, Name.Block.Inventory.Meta) },
                    { display: 'Price Override', name: Token.Inventory.DisplayPrice, type: 'checkbox', value: true, configurableDuringExport: (_, config) => Token.isTokenPresent(Token.Inventory.DisplayPrice, config, Name.Block.Inventory.Meta) }
                ],
                visible: () => false
            };
        }
    }
}

// #region LEGACY

class _ItemContainer extends React.Component {
    constructor(props) {
        super(props);

        this.containerForItems = this.containerForItems.bind(this);
        this.containerForRow = this.containerForRow.bind(this);
        this.handleColumnProps = this.handleColumnProps.bind(this);
        this.handleComponentType = this.handleComponentType.bind(this);
    }

    containerForItems(index, rows, pageHeader, pageCount) {
        let pageClassName;
        if (index < pageCount - 1) {
            pageClassName = 'pageBreakAfterAlways';
        }
        return this.props.onPageForItem(index, rows, pageHeader, pageClassName);
    }

    containerForRow(key, componentData, columnCount) {
        let columns;
        if (this.props.config && this.props.config.Columns && this.props.config.Columns.length > 0) {
            columns = [];
            for (let i = 0; i < columnCount; i++) {
                columns.push(this.props.config.Columns[0]);
            }
        }
        let _componentData = componentData || [];
        while (_componentData.length < columnCount) {
            // Pad with empty column content
            _componentData.push(undefined);
        }
        return (
            <Columns.V1.Component
                key={key}
                {...this.props}
                avoidPageBreaks={true}
                columns={columns}
                componentData={_componentData}
                dataType="container"
                renderHeader={false}
                typeHandler={this.handleComponentType}
                onColumnProps={this.handleColumnProps} />
        );
    }

    handleColumnProps(index) {
        if (!this.props.builder || index == 0) {
            return {};
        }
        return { disabled: true };
    }

    handleComponentType(type) {
        switch (type) {
            case 'itemAlternateDimensions':
                return Item.AlternateDimensions.Component;
            case 'itemArtist':
                return Item.Artist.Component;
            case 'itemCustomMeta':
                return Item.CustomMeta.Component;
            case 'itemDimensions':
                return Item.Dimensions.Component;
            case 'itemDisplayPrice':
                return Item.DisplayPrice.Component;
            case 'itemEdition':
                return Item.Edition.Component;
            case 'itemFramed':
                return Item.Framed.Component;
            case 'itemImage':
                return Item.Image.Component;
            case 'itemLocation':
                return Item.Location.Component;
            case 'itemMedium':
                return Item.Medium.Component;
            case 'itemNumber':
                return Item.Number.Component;
            case 'itemPrice':
                return Item.Price.Component;
            case 'itemSignature':
                return Item.Signature.Component;
            case 'itemSKU':
                return Item.SKU.Component;
            case 'itemTitle':
                return Item.Title.Component;
            default:
                return null;
        }
    }

    render() {
        const data = this.props.data || {};
        const inventory = data.Inventory || [];

        let columnCount = 2;
        let itemsPerPage = 4;
        if (this.props.config && this.props.config.Config && this.props.config.Config.Block) {
            let temp = parseInt(this.props.config.Config.Block.columnCount, 10);
            if (!isNaN(temp) && temp > 0) {
                columnCount = temp;
            }
            temp = parseInt(this.props.config.Config.Block.itemsPerPage, 10);
            if (!isNaN(temp) && temp > 0) {
                itemsPerPage = temp;
            }
        }
        if (itemsPerPage < columnCount) {
            columnCount = itemsPerPage;
        }
        const inventoryLength = this.props.builder ? columnCount : inventory.length;
        const pageCount = Math.ceil(inventoryLength / itemsPerPage);
        const pageHeader = this.props.onPageHeader();

        const content = [];
        let componentData = [];
        let rows = [];
        for (let i = 0; i < inventoryLength; i++) {
            if (i > 0 && i % itemsPerPage == 0) {
                // End of current page
                if (componentData.length > 0) {
                    // Add remaining row content
                    rows.push(this.containerForRow(i, componentData, columnCount));
                    componentData = [];
                }

                // Create page for row content
                content.push(this.containerForItems(content.length, rows, pageHeader, pageCount));
                rows = [];
            }

            // Add row content
            componentData.push({ index: i, itemData: i < inventory.length ? inventory[i] : undefined });

            if (componentData.length >= columnCount) {
                // Add row content to current page content
                rows.push(this.containerForRow(i, componentData, columnCount));
                componentData = [];
            }
        }
        if (componentData.length > 0) {
            // Add remaining row content
            rows.push(this.containerForRow(inventoryLength, componentData, columnCount));
        }
        if (rows.length > 0) {
            // Create remaining page for row content
            content.push(this.containerForItems(content.length, rows, pageHeader, pageCount));
        }
        return (
            <React.Fragment>
                {content}
            </React.Fragment>
        );
    }
}
const ItemContainer = Component.withBlockComponentHandler(Component.withPageHandler(_ItemContainer));

const TypeConfig = {
    panel: {
        block: function () {
            return {
                label: 'Block Configuration',
                options: [
                    {
                        display: 'Column Count',
                        name: 'columnCount',
                        options: [
                            { display: '2', value: '2' },
                            { display: '3', value: '3' },
                            { display: '4', value: '4' }
                        ],
                        relatedProperties: [
                            'col1_width',
                            'col2_width',
                            'col3_width',
                            'col4_width',
                            'col3_verticalAlign',
                            'col4_verticalAlign',
                            'col3_collapseIfEmpty',
                            'col4_collapseIfEmpty'
                        ],
                        type: 'dropdown',
                        value: '2'
                    },
                    {
                        display: 'Items Per Page',
                        name: 'itemsPerPage',
                        type: 'text',
                        value: '4'
                    },
                    ...Columns.V1.TypeConfig.options.column(
                        { display: 'Item 1 Properties', number: 1 },
                        {},
                        {
                            default: {
                                '2': '50%',
                                '3': '33.33%',
                                '4': '25%'
                            },
                            relatedProperty: 'columnCount',
                            value: '50%',
                            visible: function () { return false; }
                        },
                        { visible: function () { return false; } },
                        { value: 'middle' }
                    ),
                    { type: 'spacer' },
                    { type: 'spacer' },
                    { type: 'spacer' },
                    ...Columns.V1.TypeConfig.options.column(
                        { display: 'Item 2 Properties', number: 2 },
                        {},
                        {
                            default: {
                                '2': '50%',
                                '3': '33.33%',
                                '4': '25%'
                            },
                            relatedProperty: 'columnCount',
                            value: '50%',
                            visible: function () { return false; }
                        },
                        { visible: function () { return false; } },
                        { value: 'middle' },
                        { value: true, visible: function () { return false; } }
                    ),
                    {
                        type: 'spacer',
                        visible: function (config) {
                            return config.Block && (config.Block.columnCount == '3' || config.Block.columnCount == '4');
                        }
                    },
                    {
                        type: 'spacer',
                        visible: function (config) {
                            return config.Block && (config.Block.columnCount == '3' || config.Block.columnCount == '4');
                        }
                    },
                    ...Columns.V1.TypeConfig.options.column(
                        { display: 'Item 3 Properties', number: 3 },
                        { visible: function (config) { return config.Block && (config.Block.columnCount == '3' || config.Block.columnCount == '4'); } },
                        {
                            default: {
                                '2': undefined,
                                '3': '33.33%',
                                '4': '25%'
                            },
                            relatedProperty: 'columnCount',
                            visible: function () { return false; }
                        },
                        { visible: function () { return false; } },
                        {
                            default: {
                                '2': undefined,
                                '3': 'middle',
                                '4': 'middle'
                            },
                            relatedProperty: 'columnCount',
                            value: 'middle'
                        },
                        {
                            default: {
                                '2': undefined,
                                '3': true,
                                '4': true
                            },
                            relatedProperty: 'columnCount',
                            visible: function () { return false; }
                        }
                    ),
                    {
                        type: 'spacer',
                        visible: function (config) {
                            return config.Block && config.Block.columnCount == '4';
                        }
                    },
                    {
                        type: 'spacer',
                        visible: function (config) {
                            return config.Block && config.Block.columnCount == '4';
                        }
                    },
                    ...Columns.V1.TypeConfig.options.column(
                        { display: 'Item 4 Properties', number: 4 },
                        { visible: function (config) { return config.Block && config.Block.columnCount == '4'; } },
                        {
                            default: {
                                '2': undefined,
                                '3': undefined,
                                '4': '25%'
                            },
                            relatedProperty: 'columnCount',
                            visible: function () { return false; }
                        },
                        { visible: function () { return false; } },
                        {
                            default: {
                                '2': undefined,
                                '3': undefined,
                                '4': 'middle'
                            },
                            relatedProperty: 'columnCount',
                            value: 'middle'
                        },
                        {
                            default: {
                                '2': undefined,
                                '3': undefined,
                                '4': true
                            },
                            relatedProperty: 'columnCount',
                            visible: function () { return false; }
                        }
                    )
                ]
            };
        },
        columns: function () { return [[]]; },
        style: Columns.V1.TypeConfig.panel.style
    }
};

// #endregion LEGACY

module.exports = {
    Blocks: ItemBlocks,
    ContentContainer: ItemContentContainer,
    ComponentV2: ItemContainerV2,
    TypeConfigV2,

    // LEGACY
    Component: ItemContainer,
    TypeConfig
};